(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySmsPackageStatusViewController', CompanySmsPackageStatusViewController);

    CompanySmsPackageStatusViewController.$inject = ['entity', '$state', '$scope', '$rootScope', '$stateParams', 'CompanySubscriptionStatusCustom', 'SubscriptionPackageCustom', 'CompanyInfoQuery'];

    function CompanySmsPackageStatusViewController(entity, $state, $scope, $rootScope, $stateParams, CompanySubscriptionStatusCustom, SubscriptionPackageCustom, CompanyInfoQuery) {
        var vm = this;
        vm.subscriptionTypeList = [{type: '', packages: ''}
        ];
        vm.currentSubscriptionStatus = 'ACTIVE';

        vm.purchase = purchase;
        vm.subscriptionType = null;
        vm.selectSubscriptionType = selectSubscriptionType;
        vm.subscriptionType = '';
        vm.hasCustomSubscriptionType = false;
        selectSubscriptionType();
        vm.hasSubscription = hasSubscription;

        vm.showSubscriptionType = true;
        CompanySubscriptionStatusCustom.getCompanyTotalStatus().query(function (entity) {
            vm.companyPackageStatus = entity;
        });

        vm.buttonClass = buttonClass;
        vm.packageCardStyle = packageCardStyle;
        vm.borderStyle = borderStyle;

        $scope.$watch('vm.companySubscriptionStatusList', function (entity) {
            if (entity) {
                console.log(entity);
                loadData();
            }


        });

        function loadData() {
            makeSubscriptionPackages();
            checkSubscriptionStatus();
            //if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined &&  vm.companySubscriptionStatusList.length > 0) {
            //    vm.activePackage=vm.companySubscriptionStatusList[0];
            //    if (vm.companySubscriptionStatusList[0].subscriptionPackage != null) {
            //        if (vm.companySubscriptionStatusList[0].subscriptionPackage.subscriptionType != 'FREE') {
            //            vm.subscriptionType = vm.companySubscriptionStatusList[0].subscriptionPackage.subscriptionType;
            //            vm.mode = "purchase";
            //
            //            //selectSubscriptionType();
            //
            //        }
            //    }
            //}
        }

        function purchase() {
            vm.mode = "purchase";
        }

        function selectSubscriptionType() {

            CompanyInfoQuery.getCurrentCompanyInfo().query().$promise.then(function (result) {
                if (result.subscriptionType != null && result.subscriptionType != '') {
                    vm.subscriptionType = result.subscriptionType;
                    vm.showSubscriptionType = true;
                }

                SubscriptionPackageCustom.getSubscriptionPackageByPTypeAndSType('SMS', '').query(function (pks) {
                    if (pks)
                        var arr = [];
                        arr = pks.filter(function (pk) {
                            return pk.chargeFee > 0;
                        });
                        vm.subscriptionPackages = arr.sort(function(a, b){
                            return a.chargeFee - b.chargeFee;
                        });
                });

            })


        }

        function makeSubscriptionPackages() {

            CompanyInfoQuery.getCurrentCompanyInfo().query().$promise.then(function (result) {
                /* if(result.subscriptionType != null && result.subscriptionType!='')
                 {
                     vm.subscriptionType = result.subscriptionType;
                     vm.showSubscriptionType= false;
                     vm.hasCustomSubscriptionType=false;
                     vm.subscriptionTypeList=[{type:vm.subscriptionType,packages:''}];
                 }
                 else
                 {

                 }*/
                vm.subscriptionTypeList.forEach(function (stype) {
                    // stype.packages=SubscriptionPackageCustom.getSubscriptionPackageByPTypeAndSType('SMS','').query();
                });
            })


        }

        function checkSubscriptionStatus() {
            if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined && vm.companySubscriptionStatusList.length > 0) {
                vm.activePackage = vm.companySubscriptionStatusList[vm.companySubscriptionStatusList.length - 1];

                vm.currentSubscriptionStatus = 'ACTIVE';
            } else {
                vm.currentSubscriptionStatus = 'EXPIRED';
            }
        }

        function hasSubscription() {

            if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined && vm.companySubscriptionStatusList.length > 0) {
                if (vm.companySubscriptionStatusList[0].subscriptionPackage != null)
                    return true;
            }
            return false;
        }

        function buttonClass(type) {
            if (type != "BASIC" && type != "ECONOMY" && type != "ENTERPRISE") {
                return "btn-DEFAULT";
            }
            return "btn-" + type;
        }

        function packageCardStyle(type) {
            return "package-card-" + type;
        }

        function borderStyle(type) {
            return "border-" + type;
        }

    }
})();
